import { useEffect, useCallback } from 'react';
import { useOfflineBlade } from '@/stores/offlineBladeStore';

/**
 * Hook to monitor online/offline status and update the offline blade store.
 * Should be called once at app initialization.
 */
export function useOfflineStatus(): boolean {
  const { setOffline, isOffline } = useOfflineBlade();

  const updateOnlineStatus = useCallback(() => {
    const offline = !navigator.onLine;
    setOffline(offline);
  }, [setOffline]);

  useEffect(() => {
    // Set initial status
    updateOnlineStatus();

    // Listen for online/offline events
    window.addEventListener('online', updateOnlineStatus);
    window.addEventListener('offline', updateOnlineStatus);

    return () => {
      window.removeEventListener('online', updateOnlineStatus);
      window.removeEventListener('offline', updateOnlineStatus);
    };
  }, [updateOnlineStatus]);

  return isOffline;
}
